import PropTypes from "prop-types";
import React from "react";

const PlusMinusButton = ({expanded}) => (
  <span
    className={`faq-toggle" ${expanded ? "glyphicon-minus" : "glyphicon-plus"}`}
  />
);

PlusMinusButton.propTypes = {"expanded": PropTypes.bool.isRequired};

export default PlusMinusButton;
